export const getRuleStyles = () => ({
  listHeader: {
    display: 'flex',
    gap: '10px',
    alignItems: 'start',
    padding: '10px 0',
    '& .rule': {
      width: '450px',
    },
    '& .bid': {
      width: '70px',
    },
  },
  listFooter: {
    padding: '10px 0',
  },
  ruleEditRowContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px',
    '& .rule-edit-row': {
      display: 'flex',
      gap: '10px',
      '& .accordion-container': {
        width: '490px',
        '& .selected-rule-text': {
          fontSize: '14px',
          fontWeight: '400',
          '& .operand': {
            color: '#7C7C7C',
          },
          '& .argument-operand': {
            color: '#000000',
          },
          '& .bid': {
            color: '#000000',
          },
        },
        '& .single-rule-row': {
          display: 'flex',
          gap: '10px',
          alignItems: 'start',
          '& .rule-type-dropdown': {
            width: '160px',
            minWidth: 'unset',
          },
          '& .text-input-container': {
            width: '170px',
            "& div[role='alert'] .error": {
              marginTop: '-10px',
              marginBottom: '10px',
            },
          },
        },
        '& .and-between-rules': {
          marginBottom: '10px',
        },
        '& .single-rule-row-category': {
          alignItems: 'end',
          marginBottom: 16,
        },
        '& .bid-edit-container': {
          display: 'flex',
          flexDirection: 'column',
          marginTop: '15px',
          marginLeft: '5px',
          '& .bid-edit-input-and-currency': {
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            '& .bid-edit-input': {
              width: '120px',
              '& .fui-Input': {
                width: '100%',
              },
              "& div[role='alert'] .error": {
                color: '#A80000',
                marginTop: '10px',
                marginBottom: '10px',
              },
            },
          },
        },
      },
    },
    '& .rule-empty-error': {
      color: '#A80000',
      marginTop: '10px',
      marginBottom: '10px',
    },
    '& .duplicate-error': {
      color: '#A80000',
      marginTop: '10px',
      marginBottom: '10px',
    },
  },
});

export const getCategoryRuleStyles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    marginBottom: 8,
  },
  selector: {
    '& .fui-Combobox': {
      width: 405,
    },
  },
});
